module.exports = __webpack_public_path__ + "static/18-edd83a6bc876540caaddb9f005174a56.png";